import React, { useState } from "react";

import CustomGoogleMap from "../../../../components/GoogleMap/GoogleMap";
import "./MapAndAddress.css";

export default function MapAndAddress({ coordinates, address, city, state }) {
  const [isMapExpanded, setIsMapExpanded] = useState(false);

  return (
    <div className="grid mb-3">
      <div className="col-12 md:col-5">
        <div
          className="map-container border-round overflow-hidden"
          style={{
            height: isMapExpanded ? "400px" : "200px",
            transition: "height 0.3s ease",
            cursor: "pointer",
          }}
          onDoubleClick={() => setIsMapExpanded(!isMapExpanded)}
        >
          {coordinates?.latitude && coordinates?.longitude ? (
            <CustomGoogleMap
              center={{
                lat: parseFloat(coordinates.latitude),
                lng: parseFloat(coordinates.longitude),
              }}
            />
          ) : (
            <div
              className="flex align-items-center justify-content-center h-full"
              style={{ background: "var(--surface-ground)" }}
            >
              <i className="pi pi-map text-4xl text-color-secondary" />
            </div>
          )}
        </div>
        <p className="text-xs text-color-secondary text-center mt-1">
          Double-click to expand · Use <strong>Ctrl + Scroll</strong> to zoom
        </p>
      </div>

      <div className="col-12 md:col-7 flex align-items-start pt-2">
        <i
          className="pi pi-map-marker text-primary mr-3 mt-1"
          style={{ fontSize: "1.2rem" }}
        />
        <div>
          <div className="font-semibold text-lg">{address}</div>
          <div className="text-color-secondary">
            {city}
            {state ? `, ${state}` : ""}
          </div>
        </div>
      </div>
    </div>
  );
}
